import { Routes, Route } from "react-router-dom";

import SailingReports from "./SailingReports";
import SailingReportCreateEdit from "./SailingReportCreateEdit";
import SailingReportDetails from "./SailingReportDetails";

const index = () => {
	return (
		<Routes>
			<Route index element={<SailingReports />} />
			<Route path='/create' element={<SailingReportCreateEdit />} />
			<Route path='/:id/edit' element={<SailingReportCreateEdit />} />
			<Route path='/:id/details' element={<SailingReportDetails />} />
		</Routes>
	);
};

export default index;
